import Layout from '../../../../components/Layout';
import Menu from '../../../../components/Layout/Menu';

import PageUpdateContent from '../../../../components/Pages/Pages/[pageId]/Update';

export default function PageUpdate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Update page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <PageUpdateContent />
    </Layout>
  );
}
